function SquareDiamond(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M409.7 310.3 480 240l-70.3-70.3V70.3h-99.4L240 0l-70.3 70.3H70.3v99.4L0 240l70.3 70.3v99.4h99.4L240 480l70.3-70.3h99.4v-99.4z"></path></svg>
    )
}

export default SquareDiamond